import { Flex, Image } from "@chakra-ui/react";
import logoIcon from "../../assets/aimon/logo-text.png";
import twitterIcon from "../../assets/aimon/twitter-normal.png";
import dcIcon from "../../assets/aimon/dc-normal.png";
import tgIcon from "../../assets/aimon/tg-normal.png";
import styles from "./Header.module.scss";
import { HashLink as Link } from "react-router-hash-link";

// About
// Features
// Vimon Showcase
// Roadmap
// Community
const links = [
  { name: "About", link: "/#about" },
  { name: "Features", link: "/#features" },
  { name: "Vimon Showcase", link: "/#showcase" },
  { name: "Roadmap", link: "/#roadmap" },
  { name: "Community", link: "/#community" },
];
export default function Header() {
  return (
    <Flex className={styles.container}>
      <Image src={logoIcon} alt="logo" className={styles.logo} />

      <Flex className={styles.linkGroup}>
        {links.map((link) => (
          <Flex key={link.name} className={styles.link}>
            <Link to={link.link}>{link.name}</Link>
          </Flex>
        ))}
      </Flex>

      <Flex className={styles.socialGroup}>
        <Image src={twitterIcon} alt="logo" className={styles.social} />
        <Image src={dcIcon} alt="logo" className={styles.social} />
        <Image src={tgIcon} alt="logo" className={styles.social} />
      </Flex>
    </Flex>
  );
}

// const CButton = () => {
//   return (
//     <Flex
//       px={4}
//       py={1}
//       border="1px solid white"
//       borderRadius="full"
//       userSelect={"none"}
//       cursor={"pointer"}
//     >
//       Buy Presale
//     </Flex>
//   );
// };
